// Timeline
if ($('.oti').length > 0) {
  $(window).on('load', function () {
    $(window).on('resize', handleTimelineOrderHeight);
    handleTimelineOrderHeight();
    function handleTimelineOrderHeight() {
      $('.oti').each(function () {
        const $el = $(this);
        const $line = $el.find('.oti-line');
        const $prev = $el.prev('.oti');
        const prevHeight = $prev.length > 0 ? $prev.height() : 0;
        if (prevHeight > 0) {
          let lineHeight = prevHeight + 30;
          let translateY = lineHeight - 20;
          $line.css({
            height: lineHeight,
            transform: 'translateY(-' + translateY + 'px)',
          });
        }
      });
    }
  });
}

// Verifica se o PIX foi pago
(function () {
  'use strict';
  let pixVerTimer; // Timer para controle do 'setInterval'
  const pixVerLimit = 50; // Limite de tentativas
  const interval = 10; // Intervalo das verificações (Em segundos)
  let attemptCount = 0; // Número da tentativa atual
  const urlApi = urlBase + 'core/acoes/checkout/transaction_status.php';
  const transactionId = $('#infos-base').data('transaction-id');
  $(window).on('load', function () {
    if (transactionId && $('.verify-paid-pix').length > 0) {
      pixVerTimer = setInterval(verifyPaidPix, interval * 1000);
    }
  });
  // Verifica somente se a aba estiver ativa
  document.addEventListener('visibilitychange', function (event) {
    if (document.hidden) {
      clearInterval(pixVerTimer);
    } else {
      if (transactionId && $('.verify-paid-pix').length > 0) {
        pixVerTimer = setInterval(verifyPaidPix, interval * 1000);
      }
    }
  });
  function verifyPaidPix() {
    attemptCount++;
    $.getJSON(`${urlApi}?store_token=${storeToken}&transaction_id=${transactionId}`, function (result) {
      console.log(result);
      if (result.status == 'paid') {
        clearInterval(pixVerTimer);
        const redirectUrl = addParameterToURL('paid_pix=1');
        location.href = redirectUrl;
      }
      if (attemptCount >= pixVerLimit) {
        clearInterval(pixVerTimer);
      }
    }).fail(function (qXHR, textStatus, errorThrown) {
      console.log(qXHR);
      if (attemptCount >= pixVerLimit) {
        clearInterval(pixVerTimer);
      }
    });
  }
  function addParameterToURL(param) {
    let _url = location.href;
    _url += (_url.split('?')[1] ? '&' : '?') + param;
    return _url;
  }
})();

// QR Code Pix
(function () {
  'use strict';
  if ($('.qrcode-generate').length > 0) {
    const $qrCode = $('.qrcode-generate');
    const qrCodeTxt = $qrCode.data('qrcode');
    if (qrCodeTxt) {
      const qrCodeGenerator = new QRCode($qrCode[0], {
        text: qrCodeTxt,
        width: 250,
        height: 250,
      });
      $qrCode.addClass('generated');
      //qrCodeGenerator.makeCode(qrCodeTxt);
    }
  }
})();

// Merchant review
(function () {
  'use strict';
  if (
    LPQV.page === 'pedido' &&
    window.MERCHANT_ID !== undefined &&
    LPQV?.order?.id !== undefined &&
    LPQV?.order?.orders_shipments[0]?.estimated_delivery_date !== undefined
  ) {
    const surveyObj = {
      merchant_id: window.MERCHANT_ID,
      order_id: LPQV.order.id,
      email: LPQV.order.customer_email,
      delivery_country: 'BR',
      estimated_delivery_date: LPQV.order.orders_shipments[0].estimated_delivery_date,
      //products: [{ gtin: 'GTIN1' }, { gtin: 'GTIN2' }],
      opt_in_style: 'CENTER_DIALOG',
    };
    console.log(surveyObj);
    const script = document.createElement('script');
    script.src = 'https://apis.google.com/js/platform.js?onload=renderOptIn';
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    window.renderOptIn = function () {
      window.gapi.load('surveyoptin', function () {
        window.gapi.surveyoptin.render(surveyObj);
      });
    };
  }
})();
